import * as d3 from "d3";
import * as utils from "../utils/utils.js";
//let map = {};

export function render(data){

    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "areaplot")
        .each(function(d){

          let plotData = data.filter(e=>e._info.cl == d._userInput.key).sort((a,b)=> d3.ascending(a.c, b.c))

            let plot =  d3.select(`#${d.parentId}-areaplot`)
            let lines = plot.selectAll(`.ljs--barcode-line`)
                .data(plotData)

      
            lines.exit().remove()
            lines
                .enter().append("line").merge(lines)
                .attr("class", `ljs--barcode-line`)
                .attr("x1", e=> d.scale.x(e.x))
                .attr("x2", e=> d.scale.x(e.x))
                // .attr("y1", (e,i)=> i*4)
                .attr("y1", 0)
                .attr("y2", d.innerHeight)
                .style("stroke", (e,i)=>{
                    return utils.colors[i]
                })

        })

}

export function clear(){
    d3.selectAll(".ljs--lattice-plot")
        .filter(d=> d.type == "areaplot")
        .each(function(d){
            let plot =  d3.select(`#${d.parentId}-areaplot`)
            plot.selectAll(`.ljs--barcode-line`).remove();
        })
}

export function axis(){
    d3.selectAll(".ljs--lattice-plot")
    .filter(d=> d.type == "areaplot" && d.column == 1)
    .each(function(d){
        let plot =  d3.select(`#${d.parentId}-areaplot`)
     
        var xAxis = d3.axisBottom()
            .scale(d.scale.x)
            .tickValues([d.scale.x.domain()[0], 0, d.scale.x.domain()[1]])
            .tickSizeInner([d.innerHeight])
            


        var yAxis = d3.axisLeft()
            .scale(d.scale.y)
            .tickValues([d.scale.y.domain()[0], d.scale.y.domain()[1]])
            .tickFormat(function(tickVal) {
                return tickVal >= 1000 ? utils.roundDecimal(tickVal/1000) + "K" : tickVal;
            })
            .tickSizeInner(-d.innerWidth);

           let xticks = plot.append("g").attr("class", "axis")
                .attr("transform", `translate(0,0)`)
                .call(xAxis)

               xticks.selectAll("line").filter(d=>d==0).classed("dashed-line", true)

                xticks.selectAll("text")
                .filter(e=>e==0)
                .html("0")
            
            plot.append("g").attr("class", "axis")
                .attr("transform", `translate(0,0)`)
                .call(yAxis)
                .selectAll("text")
                .attr("dy", (e)=>{
                    if (e==0){ return 0 }
                    else { return utils.dy.tick }
                })


            if (d.row==0){
                plot.append("text").html("Count")
                    .attr("class", "sm-axis-title")
                    .attr("transform", `rotate(-90)`)
                    .attr("x", -d.innerHeight/2)
                    .attr("y", -d.padding.left*.8)
                    .attr("text-anchor", "middle")
    
                plot.append("text").html("Position")
                    .attr("class", "sm-axis-title")
                    .attr("x", d.innerWidth/2)
                    .attr("y", d.innerHeight + (d.padding.bottom/1.5))
                    .attr("text-anchor", "middle")
            }

    })
}